export const selectAssignments = ({ assignments }) => assignments.assignments
export const selectAssignment = ({ assignments }) => assignments.assignment
export const selectSurvey = ({ assignments }) => assignments.survey
export const selectAssignmentAnswers = ({ assignments }) => assignments.assignmentAnswers
